import { WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR } from "@/constants";
import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import { RewardsEarnPointsCartWidgetDefinition } from "@apps/rewards/constants/definitions";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import { parseOptionalBooleanDataAttr } from "@ui-utils/Injector/utils";

import type { RewardsEarnPointsCartWidgetInjectorConfig } from "./types";

const CART_TOTAL_PRICE_ATTR = "gw-cart-total-price";

class RewardsEarnPointsCartWidgetInjector {
    constructor(
        private readonly config: RewardsEarnPointsCartWidgetInjectorConfig
    ) {}

    start(): void {
        this.config.logger.debug("RewardsEarnPointsCartWidgetInjector start", {
            placeholderSelector: this.config.placeholderSelector,
        });
        const { REWARDS_EARN_POINTS_CART_WIDGET } = REWARDS_WIDGET_NAMES;

        this.config.mutationObserverInjector
            .register({
                targetSelector: this.config.placeholderSelector,
            })
            .subscribe((placeholder) => {
                this.config.logger.debug(
                    "RewardsEarnPointsCartWidgetInjector found placeholder",
                    {
                        placeholder,
                    }
                );

                void (async () => {
                    const EarnPointsCartWidget =
                        await this.config.dynamicImportManager.importDefault(
                            RewardsEarnPointsCartWidgetDefinition,
                            true
                        );

                    const widget = new EarnPointsCartWidget(
                        {
                            target: placeholder,
                            isWidgetShadowRootEnabled:
                                parseOptionalBooleanDataAttr(
                                    placeholder,
                                    WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR
                                ),
                            cartTotalPrice$:
                                this.config.attributesObserver.observe(
                                    placeholder,
                                    CART_TOTAL_PRICE_ATTR
                                ),
                        },
                        this.config.logger
                    );

                    await widget.init();

                    this.config.eventsCollector.pushEvent(
                        this.config.eventsFactory.createWidgetInjected(
                            REWARDS_EARN_POINTS_CART_WIDGET
                        )
                    );

                    dispatchSdkEvent(
                        new WidgetInjectedSdkEvent(
                            REWARDS_EARN_POINTS_CART_WIDGET
                        )
                    );
                })();
            });
    }
}

export default RewardsEarnPointsCartWidgetInjector;
